import Cookies from 'js-cookie'
import DomainName from './domain'

/**
 * @module auth
 * @category client
 */

const TokenKey = /** @type {const} */ ('sessionToken')

/**
 *  @category client
 *  @hideconstructor
 */
class Auth {
  /**
   * Retrieves the session token from cookies.
   *
   * @returns {string|undefined} The session token, or undefined if not found.
   */
  static getToken () {
    return Cookies.get(TokenKey)
  }

  /**
   * Sets a new session token in cookies.
   *
   * @param {string} token - The new session token to set.
   * @returns {void}
   */
  static setToken (token) {
    return Cookies.set(TokenKey, token, { domain: DomainName })
  }

  /**
   * Removes the session token.
   *
   * @returns {void}
   */
  static removeToken () {
    return Cookies.remove(TokenKey, { domain: DomainName })
  }
}

export default Auth
